import React, { Fragment, useEffect, useRef } from 'react';
import Controls from './components/Controls';
import { useGenericCarousel } from './hooks/useGenericCarousel';
import './style.scss';

export const GenericCarousel = ({
  children,
  carouselTitle,
  carouselKey = '',
  classNames = [''],
  prevArrowIcon,
  nextArrowIcon,
  prevIconClassName = '',
  nextIconClassName = '',
  spaceBetween= 24
}) => {
  const carouselRef = useRef(null);

  const {
    canDoCarousel,
    handleNext,
    handlePrev,
    handleDragEnd,
    handleDragOver,
    handleDragStart,
    trackRef,
  } = useGenericCarousel({ wrapperRef: carouselRef, spaceBetween });

  return (
    <div className={['cv-generic-carousel', ...classNames].join(' ')}>
      <Controls
        title={carouselTitle}
        handleNextSlide={handleNext}
        handlePrevSlide={handlePrev}
        showControls={canDoCarousel}
        carouselKey={carouselKey}
        nextArrowIcon={nextArrowIcon}
        prevArrowIcon={prevArrowIcon}
        prevIconClassName={prevIconClassName}
        nextIconClassName={nextIconClassName}
      />
      <div className="cv-generic-carousel__wrapper" ref={carouselRef}>
        <div
          className="cv-generic-carousel__wrapper__track"
          onDragOver={handleDragOver}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
          ref={trackRef}
          style={{ columnGap: spaceBetween }}
        >
          <Fragment>{children}</Fragment>
        </div>
      </div>
    </div>
  );
};
